// CANONICAL COPY (GH #7115). src/constants/obligations/obl-approved-processing-locations.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-approved-processing-locations',
  title: 'Verify processing occurs only at controller-approved locations',
  description:
    'Confirm that personal-data processing and storage occur only at the locations, countries or regions agreed with the controller in each DPA (FSR ISAE 3000 Kontrolmål E.1–E.2). The processor shall maintain a register of processing locations per DPA, enforce location constraints in hosting / cloud configuration, and notify the controller before any proposed location change. Review the processing-locations standard, the per-DPA location register, and cloud / hosting configuration evidence demonstrating the constraint is enforced.',
  category: 'compliance',
  scfIds: ['SCF-VDR-005', 'SCF-PRV-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Approved-processing-locations procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
